module EEX.McEc.Controls.CertificateGrid {

    // ReSharper disable once InconsistentNaming
    interface CertificateGridHelperResult {
        columns: kendo.ui.GridColumn[],
        schema: kendo.data.DataSourceSchemaModelField[],
    }

    // ReSharper disable once InconsistentNaming
    interface GridItem {
        field: string,
        title: string,
        width?: number | string,
    }

    export class CertificateGridHelper {
        public static getGridConfig(gridItems: GridItem[]): CertificateGridHelperResult {
            const columns: kendo.ui.GridColumn[] = [];
            const schema: kendo.data.DataSourceSchemaModelField[] = [];

            for (let item of gridItems) {
                columns.push(this.getColumn(item));
                schema.push(this.getSchema(item));
            }

            return {
                columns: columns,
                schema: schema
            }
        }

        public static getCertificateGridItem(): GridItem[] {
            return [
                {
                field: "CertificateNr",
                title: McEc.Strings.CertificatesListe_HeaderCertificateNr,
                width: 70
            },
            {
                field: "CreatedDate",
                title: McEc.Strings.CertificatesListe_HeaderCreated
                },
                {
                field: "NotBefore",
                title: McEc.Strings.CertificatesListe_HeaderValidFrom
            },
            {
                field: "NotAfter",
                title: McEc.Strings.CertificatesListe_HeaderValidTo
            },
            //{
            //    field: "CreatedUserId",
            //    title: "CreatedUserId",
            //},
            {
                field: "State",
                title: McEc.Strings.CertificatesListe_HeaderState,
                width: 100
            },
            {
                field: "Action",
                title: McEc.Strings.CertificatesListe_HeaderAction,
                width: 220
            }];
        }

        public static getServerCertificateGridItem(): GridItem[] {
            return [
                {
                    field: "CertificateNr",
                    title: McEc.Strings.CertificatesListe_HeaderCertificateNr,
                    width: 70
                },
                {
                    field: "CreatedDate",
                    title: McEc.Strings.CertificatesListe_HeaderCreated
                },
                {
                    field: "NotBefore",
                    title: McEc.Strings.CertificatesListe_HeaderValidFrom
                },
                {
                    field: "NotAfter",
                    title: McEc.Strings.CertificatesListe_HeaderValidTo
                },
                {
                    field: "CreatedUserId",
                    title: McEc.Strings.CertificatesListe_HeaderCreatedUserId
                },
                {
                    field: "State",
                    title: McEc.Strings.CertificatesListe_HeaderState,
                    width: 100
                },
                {
                    field: "Action",
                    title: McEc.Strings.CertificatesListe_HeaderAction,
                    width: 220
                }];
        }

        private static getColumn(item: GridItem): kendo.ui.GridColumn {
            return {
                field: item.field,
                title: item.title,
                width: item.width
            }
        }

        private static getSchema(item: GridItem): kendo.data.DataSourceSchemaModelField {
            return {
                field: item.field
            }
        }
    }

    export class CertificateGridModel extends AppKitchen.Controls.Grids.GridModel {

        constructor(gridItems: GridItem[], onDownload: (e: any) => void, onRevoke: (e: any) => void) {
            const gridConfig = CertificateGridHelper.getGridConfig(gridItems);

            super(gridConfig.columns, gridConfig.schema);

            this.attachCommand(onDownload, onRevoke);
        }

        attachCommand(onDownload: (e: any) => void, onRevoke: (e: any) => void) {
            const columns = this.get().columns;
            const actionColumn = this.getActionColumn(columns);

            if (actionColumn) {
                actionColumn.command = [
                    {
                        text: McEc.Strings.CertificatesListe_Action_Download,
                        click: (e) => {
                            e.preventDefault();
                            onDownload(e);
                        },
                        visible: (dataItem) => { return dataItem["State"] === 5; }
                    },
                    {
                        text: McEc.Strings.CertificatesListe_Action_Revoke,
                        click: (e) => {
                            e.preventDefault();
                            onRevoke(e);
                        },
                        visible: (dataItem) => { return dataItem["State"] === 5; }
                    }
                ];
            }
        }

        private getActionColumn(columns: kendo.ui.GridColumn[]): kendo.ui.GridColumn {
            return columns.AsLinq<kendo.ui.GridColumn>().FirstOrDefault(c => c.field === "Action");
        }
    }
}
